window.errorReportCount = 0;
window.maxErrorReports = 2;

window.testErrorReport = function() {
    setTimeout(function(){ window.testabc.test123 = 1; }, 1000);
}

//console.log(JSON.stringify(window.environment_settings, null, 2));

if(window.environment_settings.MIX_HANDLE_ERRORS) {

    window.onerror = function(msg, url, line, col, error) {
        var data;

        if(window.errorReportCount < window.maxErrorReports) {
            if(typeof error === 'object' && error !== null) {
                data = {
                    navigator: navigator.userAgent,
                    uri: window.location.href,
                    name: error.name,
                    msg: error.message,
                    fileName: error.fileName,
                    line: error.lineNumber,
                    col: error.columnNumber,
                    stack: error.stack,
                    error_report_subject: "JavaScript error - onerror/object",
                };
            }
            else {
                data = {
                    navigator: navigator.userAgent,
                    uri: window.location.href,
                    name: undefined,
                    msg: msg,
                    fileName: url,
                    line: line,
                    stack: "",
                    error_report_subject: "JavaScript error - onerror/non-object",
                };
            }
            data["routeHistory"] = window.routeHistory;
            //console.error(data);
            window.errorReportCount++;
            // Filter out the errors that are in external packages, or that we know about
            // and can do nothing about.
            if(("" + data.fileName).startsWith('https://www.gruveo.com') === false
                    && ("" + data.fileName).startsWith('https://cdn.nickelled.com') === false
                    && ("" + data.fileName).startsWith('https://cdn.fusioncharts.com') === false
                    && data.name != 'QuotaExceededError'
                    && data.msg != 'Script error.'
                    && data.msg != "Can't find variable: gmo"
                    && ("" + data.msg).includes("ResizeObserver") === false
                    && ("" + data.stack).includes('_avast') === false
                    // https://discuss.newrelic.com/t/exception-in-nrwrapper/72759/7
                    && ("" + data.stack).includes("nrWrapper") === false
					// This was actually triggered by an issue with the Vue upgrade,
					// and unrolled refs with Gruveo, so I've left it in again
					// since the issue is now fixed.
					//&& ("" + data.msg).includes("__v_isRef") === false
				) {
                axios.post('/api/v0/error', data).then((res) => {
                }).catch((error) => {
                });
            }
        }
        if(window.environment_settings.MIX_HANDLE_ERRORS === "2") {
            return false;
        }
        return true;
    };
    //window.testabc.test123 = 1;
    console.info(Vue.config.errorHandler);
    Vue.config.errorHandler = (error, vm, info) => {
        var data;

        if(window.errorReportCount < window.maxErrorReports) {

            if(typeof error === 'object') {
                data = {
                    navigator: navigator.userAgent,
                    uri: window.location.href,
                    name: error.name,
                    msg: error.message,
                    fileName: error.fileName,
                    line: error.lineNumber,
                    col: error.columnNumber,
                    stack: error.stack,
                    vueInfo: info
                };
            }
            else {
                data = {
                    navigator: navigator.userAgent,
                    uri: window.location.href,
                    vueInfo: info
                };
            }
            data["routeHistory"] = window.routeHistory;
            //console.log(data);
            window.errorReportCount++;

            axios.post('/api/v0/error', data).then((res) => {
            }).catch((error) => {
            });
        }
        if(window.environment_settings.MIX_HANDLE_ERRORS === "2") {
            throw(error);
        }
    };
}
